
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { SensorStore, FarmStore, CommonStore } from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { SensorLocationHistory } from '@/store/models/sensor';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    LocationInputMap
  }
})
export default class SensorLocationForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  sensorLocationId = 0;
  get sensorLocation() {
    return JSON.parse(JSON.stringify(SensorStore.AddEditSensorLocation));
  }

  get sensorAttached() {
    if (this.sensorLocationHistory && this.sensorLocationHistory.id) {
      return true;
    }
    return false;
  }

  get emptyBlockSensor() {
    return {} as SensorLocationHistory;
  }

  get sensorLocationHistory() {
    const sensorLocationHistory = JSON.parse(
      JSON.stringify(SensorStore.CurrentSensorLocationSensor)
    );
    return sensorLocationHistory;
  }

  set sensorLocationHistory(sensorLocationHistory: SensorLocationHistory) {
    SensorStore.setCurrentSensorLocationSensor(sensorLocationHistory);
  }

  get submitLabel() {
    return 'Attach';
  }

  get currentFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  detachDialog = false;
  get sensors() {
    // return FarmStore.FarmSensors.filter(
    //   x => x.farm == this.currentFarmBlock.farmId
    // ).map(x => {
    //   return { value: x.sensorId, label: x.sensorName };
    // });
    return SensorStore.Sensors.map(x => {
      return {
        value: x.id,
        label: x.sensorId
      };
    });
  }

  async onSubmit() {
    const sensorLocationHistory = {
      sensorLocation: this.sensorLocationId,
      sensorId: this.sensorLocationHistory.sensorId
    };
    await SensorStore.attachSensorLocation(sensorLocationHistory);
    this.$q.notify({
      type: 'positive',
      message: 'Sensor attached successfully'
    });
    this.$router.push({ name: 'SensorLocationList' });
  }

  onReset() {
    requestAnimationFrame(() => {
      this.sensorLocationHistory = JSON.parse(
        JSON.stringify(this.emptyBlockSensor)
      );
      this.$refs.observer.reset();
      this.$router.push({ name: 'SensorLocationList' });
    });
  }

  async onDetach() {
    this.detachDialog = false;
    if (
      this.sensorLocationHistory &&
      this.sensorLocationHistory.id &&
      this.sensorLocationHistory.id != 0
    ) {
      await SensorStore.detachSensorLocation(this.sensorLocationId);
      this.$q.notify({
        type: 'positive',
        message: 'Sensor detached successfully'
      });
    }
  }

  detachSensor() {
    this.detachDialog = true;
  }

  async created() {
    // FarmStore.getAllFarmSensor();
    SensorStore.getSensors();
    if (this.$route.params.sensorLocationId) {
      this.sensorLocationId = Number(this.$route.params.sensorLocationId);
      await SensorStore.getSensorLocationById(this.sensorLocationId);
      await SensorStore.getSensorLocationHistoryBySensorLocationId(
        this.sensorLocationId
      );
    }
  }
}
